import { Accordion, Stack } from '@mantine/core';
import PartialRunGroupItem from '@/pages/AutomationPage/components/ManualRunModal/components/PreviousRunUI/PartialRunGroupItem.tsx';
import PerfectRunGroupItem from '@/pages/AutomationPage/components/ManualRunModal/components/PreviousRunUI/PerfectRunGroupItem.tsx';
import { PreviousRunGroupListProps } from '@/pages/AutomationPage/components/ManualRunModal/components/PreviousRunUI/types.ts';

const PreviousRunGroupList = ({
  groups,
  triggers,
  getRunUrl,
  selectedPreviousRunId,
  onSelectPerfectRun,
  onSelectPartialRun,
  isPartial = false,
}: PreviousRunGroupListProps) => {
  return (
    <Stack style={{ border: '1px solid #ECECEC', borderRadius: 4 }}>
      <Accordion multiple={true} chevronPosition={'right'} variant={'default'}>
        {groups.map((group, index) =>
          isPartial ? (
            <PartialRunGroupItem
              key={group.key}
              group={group}
              isLast={index === groups.length - 1}
              triggers={triggers}
              getRunUrl={getRunUrl}
              onSelectPartialRun={onSelectPartialRun}
            />
          ) : (
            <PerfectRunGroupItem
              key={group.key}
              group={group}
              isLast={index === groups.length - 1}
              selectedPreviousRunId={selectedPreviousRunId}
              getRunUrl={getRunUrl}
              onSelectPerfectRun={onSelectPerfectRun}
            />
          ),
        )}
      </Accordion>
    </Stack>
  );
};

export default PreviousRunGroupList;
